import Users from './Users'
import UsersListItem from './UsersListItem'
import UsersSingle from './UsersSingle'
import Overview from './Overview'
import UserSingleDetails from './UserSingleDetails'
import UsersSinglePermissions from './UsersSinglePermissions'
import Timesheet from './Timesheet'
import ScheduledTasks from './ScheduledTasks'

export default {
    Users,
    UsersListItem,
    UsersSingle,
    Overview,
    UserSingleDetails,
    UsersSinglePermissions,
    Timesheet,
    ScheduledTasks
}
